<template>
  <div class="home-base">
    <router-view />
    <div v-if="$route.meta.footer.show && !$IFR.is_iframe" class="common-footer-wrap">
      <mt-tabbar v-model="home_selected" fixed class="common-footer">
        <!-- 首页 -->
        <mt-tab-item class="item-wrap button" :class="{ active: $route.name == 'HomeIndex' }" id="home_index">
          <router-link :to="{ name: 'HomeIndex' }" class="item">
            <img src="../../assets/image/tab/icon_home_pre.png" class="image" v-if="$route.name == 'HomeIndex'" />
            <img v-else src="../../assets/image/tab/icon_home_nor.png" class="image" />
            <span class="text">{{ $t("Home") }}</span>
          </router-link>
        </mt-tab-item>

        <!-- 分享 -->
        <mt-tab-item class="item-wrap button" :class="{ active: ($route.name == 'Shares' || $route.name == 'ShareList') }" id="home_goodsclass">
          <router-link :to="{ name: 'Shares' }" class="item">
            <img src="../../assets/image/share_pre.png" class="image" v-if="$route.name == 'Shares' || $route.name == 'ShareList'" />
            <img v-else src="../../assets/image/share.png" class="image" />
            <span class="text"> {{ $t("Share") }}</span>
          </router-link>
        </mt-tab-item>
        
        <!-- 礼品卡列表 -->
        <mt-tab-item class="item-wrap button" :class="{ active: ($route.name == 'GiftCardList' || $route.name == 'MyCardList' || $route.name == 'GiftCardDetails') }" id="home_cart">
          <router-link :to="{ name: 'GiftCardList' }" class="item">
            <img src="../../assets/image/tab/icon_gift_pre.png" class="image" v-if="$route.name == 'GiftCardList' || $route.name == 'MyCardList' || $route.name == 'GiftCardDetails'" style="width: unset;"/>
            <img v-else src="../../assets/image/tab/icon_gift.png" class="image" style="width: unset;"/>
            <span class="text">{{$t("MenuGiftCard")}}</span>
          </router-link>
        </mt-tab-item>

        <!-- 回收 -->
        <mt-tab-item class="item-wrap button" :class="{ active: $route.name == 'GiftSave' }" id="home_search">
          <router-link :to="{ name: 'GiftSave' }" class="item">
            <img src="../../assets/image/tab/Recycle_pre.png" class="image" v-if="$route.name == 'GiftSave'" />
            <img v-else src="../../assets/image/tab/Recycle.png" class="image" />
            <span class="text">{{ $t("Recycle") }}</span>
          </router-link>
        </mt-tab-item>

        <!-- 个人中心 -->
        <mt-tab-item class="item-wrap button" :class="{ active: $route.name == 'MemberIndex' }" id="member_index">
          <router-link :to="{ name: 'MemberIndex' }" class="item">
            <img src="../../assets/image/tab/icon_mine_pre.png" class="image" v-if="$route.name == 'MemberIndex'" />
            <img v-else src="../../assets/image/tab/icon_mine_nor.png" class="image" />
            <span class="text">{{ $t("Mine") }}</span>
          </router-link>
        </mt-tab-item>
      </mt-tabbar>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { cartQuantity } from "../../api/homecart";
export default {
  name: "HomeBase",
  data() {
    return {
      home_selected: "home_index",
      cartNumber: 0,
    };
  },
  computed: {
    ...mapState({
      isOnline: (state) => state.member.isOnline,
      showSpecialFooter: (state) => state.home.showSpecialFooter,
    }),
    showFooter() {
      if (
        this.$route.name == "HomeIndex" ||
        this.$route.name == "HomeSpecial" ||
        this.$route.name == "HomeActivitydetail"
      ) {
        return this.showSpecialFooter;
      } else {
        return true;
      }
    },
    getCarCount() {
      if (this.cartNumber > 0 && this.cartNumber < 100) {
        return this.cartNumber;
      } else if (this.cartNumber >= 100) {
        return "99+";
      }
    },
  },
  created: function () {
    if (this.$route.query.inviter_id) {
      this.memberInviterId({ inviterId: this.$route.query.inviter_id });
    }
    // this.getCartCount();

    if (this.$route.query.is_iframe) {
      this.$IFR.is_iframe = this.$route.query.is_iframe;
    }
  },
  methods: {
    ...mapMutations({
      memberInviterId: "memberInviterId",
    }),
    getCartCount() {
      if (this.isOnline) {
        cartQuantity().then((res) => {
          if (res) {
            this.cartNumber = res.result.cart_count;
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item-wrap {
  position: relative;
}

.image {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.icon {
  position: absolute;
  right: 0.8rem;
  top: 0.2rem;
  font-size: $h6;
  line-height: 0.7rem;
  width: 0.9rem;
  height: 0.7rem;
  background: #ef3338;
  border-radius: 1rem;
  text-align: center;
  color: #ffffff;
}
</style>
